

<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div class="tab-box">
        <div class="tab-scroll">
          <div v-for="(item,index) in dataList" :key="index">
            <div @click="goVideoDetails(item,index)" class="video-list">
              <div class="hd">
                <img v-bind:src="item.ImgPath" class="avatar" />
                <div class="playIcon">
                  <van-icon name="play-circle-o" color="#fff" size="36" />
                </div>
              </div>
              <div class="bd">
                <h2 class="title van-multi-ellipsis--l2">{{item.Title}}</h2>
                <p class="date">{{item.AddDateTime}}</p>
                <div v-if="ischeckShow" class="ck">
                  <input ref="videockbox" @click="goVideoDetails(item,index)" type="checkbox" :value="item.VideoID" />
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      pageRows: 10,
      id: 0
    };
  },
  props: {
    // id: {
    //   // 纪念馆id
    //   type: String
    // },
    // fullHeight: {
    //   // 浏览器高度
    //   type: Number
    // },
    isSelf: {
      type: Boolean
    },
    ischeckShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["currentToken"])
  },
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "GetVideoVideoSearchList",
        pageIndex: 1,
        id: this.id,
        PageRows: that.pageRows
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.VideoApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }
          if (dataList.length < that.pageRows) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    },
    goVideoDetails(item, index) {
      var that = this;
      if (this.ischeckShow) {
        this.$refs.videockbox[index].checked = !this.$refs.videockbox[index]
          .checked;
      } else {
        this.$router.push({
          path: "/VideoDetails",
          query: { id: item.SerialNumber , mid : this.id}
        });
      }
    },
    delVideo() {
      var that = this;
      Dialog.confirm({
        message: "确定删除这些视频吗？"
      }).then(
        () => {
          var params = {
            type: "VideoDelVue",
            Id: that.id,
            VideoIDs: []
          };
          that.$refs.videockbox.map(e => {
            if (e.checked) {
              params.VideoIDs.push(e.value);
            }
          });
          if (params.VideoIDs.length == 0) {
            Toast("未选中视频");
            return;
          } else {
            that.$store.dispatch(params).then(
              res => {
                if (res.IsSuccess) {
                  that.onRefresh();
                  Toast(res.Message);
                } else {
                  Toast(res.Message);
                }
              },
              err => {}
            );
          }
        },
        () => {}
      );
    }
  },
  activated() {
    var that = this;
    this.id = this.$route.query.id;
    that.init();
  },
  created() {
    var that = this;
    this.id = this.$route.query.id;
    that.init();
  }
};
</script>


<style scoped>
.photo-list {
  display: flex;
  align-items: center;
  margin: 10px;
  background-color: #f2f2f2;
  height: 128px;
}
.photo-list > .hd {
  flex: 1;
  width: 100%;
  height: 100%;
}
.photo-list > .hd > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.photo-list > .bd {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.photo-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
}
.photo-list > .bd > .totalnum {
  font-size: 12px;
  color: #999;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.video-list {
  display: block;
  margin: 15px;
  border-radius: 6px;
  box-shadow: 0 0 4px #ddd;
  background-color: #f2f2f2;
}
.video-list > .hd {
  position: relative;
  height: 0;
  font-size: 0;
  padding-bottom: 56%;
  width: 100%;
}
.video-list > .hd > .avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px 6px 0 0;
}
.video-list > .hd > .playIcon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-list > .bd {
  padding: 10px;
}
.video-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.video-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list {
  margin: 15px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding: 10px;
}
.audio-list > .hd {
  position: relative;
  margin-right: 15px;
}
.audio-list > .hd > i {
  color: #666;
  font-size: 24px;
}
.audio-list > .bd {
  flex: 1;
  overflow: hidden;
}
.audio-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tab-box {
  position: relative;
}
.tab-scroll {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.photos-content .addBtn {
  position: absolute;
  bottom: 20px;
  right: 15px;
  width: 56px;
  height: 56px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #24a378;
  z-index: 100;
}
.ck {
  align-content: flex-start;
}
</style>



